import React from "react";
import "./uploads.css";
import { VscFilePdf } from "react-icons/vsc";
import { AiOutlineFileWord } from "react-icons/ai";
import { Link } from "react-router-dom";
const files = [
  {
    file_name: "Каталог — фаза 1",
    file_type: "pdf",
    file_size: "13.76 МБ",
    file_date: "01.05.2021",
  },
  {
    file_name: "Каталог — фаза 2",
    file_type: "word",
    file_size: "3.81 МБ",
    file_date: "17.06.2021",
  },
  {
    file_name: "Каталог — фаза 3",
    file_type: "pdf",
    file_size: " 17.59 МБ",
    file_date: "30.06.2021",
  },
  {
    file_name: "Технические характеристики - фаза 1",
    file_type: "pdf",
    file_size: "2.07 МБ",
    file_date: "10.08.2021",
  },
  {
    file_name: "Паркинг",
    file_type: "pdf",
    file_size: "2.3 МБ",
    file_date: "10.08.2021",
  },
];

function Uploads(props) {
  return (
    <div className="contianer my-5">
      <h2 className="fs-1 text-center">Материалы</h2>
      <hr className="divider my-5" />
      <h3 className="text-center">
        Буклеты{" "}
        <span style={{ borderRadius: "15px" }} className="badge  bg-info">
          {files.length}
        </span>
      </h3>
      <div className="container">
        <hr className="divider   my-5" />
      </div>
      <div className="container ">
        <div className="row">
          {files.map((e, i) => (
            <Link key={i} className="my-3" to="file_path">
              <div className="col-sm-12 p-3">
                <div className="row shadow-custom  p-2 rounded-50">
                  <div className="col-3 d-flex justify-content-center align-items-center">
                    <h2 className="fs-1">
                      {e.file_type.toLocaleLowerCase() === "pdf" ? (
                        <VscFilePdf
                          style={{
                            color: "red",
                          }}
                        />
                      ) : (
                        <AiOutlineFileWord />
                      )}
                    </h2>
                  </div>
                  <div className="col-7 d-inline-block">
                    <h2 className="fs-5 my-2">
                      File name: <strong>{e.file_name}</strong>
                    </h2>
                    <div className="">
                      <p>
                        File size: <strong>{e.file_size} </strong>
                      </p>
                      <p>
                        Date: <strong>{e.file_date}</strong>
                      </p>
                      <p>
                        File Type: <strong>{e.file_type}</strong>{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Uploads;
